import base64Conversion from './base64conversion';

export default function getStudentTardies(schoolCode, studentNo, studentId, periodId) {
  const header = base64Conversion();
  return fetch(`${process.env.REACT_APP_API_HEAD}/getStudentTardiesAndDetentionsDetails/tardy`, {
    method: 'POST',
    body: JSON.stringify({
      school_code: schoolCode,
      student_no: studentNo,
      student_id: studentId,
      period: periodId,
    }),
    headers: {
      'content-type': 'application/json',
      Authorization: header,
    },
  })
    .then((res) => res.json());
}
